<template>
    <div>
        <div class="request-container">
            <h4 class="title">{{ $t('modals.patient_profile.profile.request.card_head') }}</h4>

            <request-tabs @toggle="toggleTab"></request-tabs>
            <div class="tab-content">
                <request-tab-content
                    :physician="{
                        NetworkTab: isNetworkTabActive,
                        EmailTabs: isEmailTabActive,
                        HipaaTab: isHipaaTabActive,
                    }"
                    @toggle="toggleTab"
                    @refresh-record-request="getPatientRecordRequest"
                ></request-tab-content>
            </div>
        </div>
        <record-form :patientRecordRequests="patientRecordRequests"></record-form>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import RequestTabs from 'components/forms/patient/RequestTabs'
    import RequestTabContent from 'components/forms/patient/RequestTabContent'
    import RecordForm from 'components/forms/record-request/RecordForm'
    import PatientRecordsAPI from '../../../api/PatientRecordsAPI'

    export default {
        name: 'request-records-form',
        mixins: [FormMixin, HandleRequestMixin],
        components: {
            RecordForm,
            RequestTabs,
            RequestTabContent,
        },
        data() {
            return {
                isNetworkTabActive: true,
                isEmailTabActive: false,
                isHipaaTabActive: false,
                patientRecordRequests: [],
            }
        },
        methods: {
            toggleTab(name) {
                this.isNetworkTabActive = false
                this.isEmailTabActive = false
                this.isHipaaTabActive = false
                switch (name) {
                    case 'network':
                        this.isNetworkTabActive = true
                        break
                    case 'email':
                        this.isEmailTabActive = true
                        break
                    case 'hipaa':
                        this.isHipaaTabActive = true
                        break
                }
            },

            getPatientRecordRequest() {
                PatientRecordsAPI.getPatientRecordRequest(
                    this.$auth.getActiveMember()?.id,
                    this.$auth.getUser()?.practiceId,
                    this.$route.params.id,
                ).then((res) => {
                    this.patientRecordRequests = res
                })
            },
        },

        mounted() {
            this.getPatientRecordRequest()
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .request-container {
        padding: 20px 30px;
        border-radius: 8px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        margin-bottom: 30px;
    }
    .title {
        font-weight: 400;
        color: $color-black;
        margin-bottom: 20px;
    }
</style>
